



import {Component, Prop, Vue} from 'vue-property-decorator';
import {GROW_TREE_MODAL_TYPE} from "@/constants";
import {MilestoneInterface} from "@/share/types/interface";

@Component({})
export default class StepCardInfo extends Vue {
  @Prop({required: false, type: String}) category !: string
  @Prop({type: Number, default: GROW_TREE_MODAL_TYPE.STEP}) type!: number
  @Prop() milestone ?: MilestoneInterface

  private get isStep(): boolean {
    return this.type == GROW_TREE_MODAL_TYPE.STEP
  }

  private get isMilestone(): boolean {
    return this.type == GROW_TREE_MODAL_TYPE.MILESTONE
  }

  private get classNameType(): string {
    if (this.isMilestone) return 'milestone'
    if (this.isStep) return 'step'
    return 'island'
  }
}
